<template>
    <div class="peribox">
        <div class="perititle">
            <div>Urlshortener</div>
            <div class="periicons">
                <i class="far fa-sync-alt" @click="refresh"></i>
            </div>
        </div>

        <table class="peritable" v-loading="loading">
            <tbody>
            <tr>
                <th v-for="c in columns">{{ c }}</th>
            </tr>
            <tr v-for="row in rows">
                <td v-for="c in columns">{{ row ? row[c] : '' }}</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props: [
        'app_id'
    ],
    data() {
        let columns = [
            'key',
            'driver_id',
            'employer_id',
            'application_id',
            'job_id',
            'date_created',
            'date_clicked_first',
            'date_clicked_last',
            'tag',
            'link'
        ];
        return {
            rows: null,
            columns: columns,
            loading: true
        };
    },
    methods: {
        refresh() {
            this.loading = true;
            axios.get(url(`urlshortener/test/byapp/${this.app_id}`))
                .then((response) => {
                    this.rows = response.data.rows;
                    this.loading = false;
                });
        }
    },
    mounted() {
        this.refresh();
    }
}
</script>

<style>
</style>